import { setPolyfills, getGrowthBookSSRData } from '@growthbook/growthbook-react'
import { config } from 'utils/config'
import { getClientKey } from './getClientKey'

const getServerSideGrowthBookContext = (attributes: Record<string, any>) => {
  setPolyfills({
    fetch: globalThis.fetch || require('isomorphic-unfetch')
  })

  return {
    apiHost: 'https://cdn.growthbook.io',
    clientKey: getClientKey(),
    enableDevMode: config.apiEnv === 'development',
    attributes
  }
}

export const loadFeaturesServerSide = async (attributes: Record<string, any> = {}) => {
  const gbContext = getServerSideGrowthBookContext(attributes)

  return getGrowthBookSSRData(gbContext)
}
